
// const devServer = 'http://dev.hlusta.forlagid.is/'
const proServer = 'https://hlusta.forlagid.is/'
const localServer = 'http://fartolva.snara.is/'

// export let host = (window.location.hostname === 'localhost' || window.location.hostname === 'dev.hlusta.forlagid.is') ? devServer : proServer
let host = ''
switch (window.location.hostname) {
  case 'localhost':
  case 'dev.hlusta.forlagid.is':
    host = proServer
    // host = devServer
    break
  case 'fartolva.snara.is':
    host = localServer
    break
  default:
    host = proServer
}
export let uiApi = host + 'api/ui/'
export let stream = host + 's/'



// WEBPACK FOOTER //
// ./src/url.js